export default "__VITE_ASSET__4fa7b6e9__"